import { createSlice } from "@reduxjs/toolkit";
import buildAction from "../../helpers/buildAction.ts";
import thunks from "./thunks";
import { IAdminSlice } from "@/redux/slices/admin/types";
import { ImportTheme } from "@template/theme";

export const initialState: IAdminSlice = {
  sidebar_tab: "pages",
  sidebar_tab_sub: "",
  pages: [],
  current_page: "",
  loading: true,
  permissions: {},
  theme: {} as ImportTheme,
  config: {
    sitemap: null,
    robots: null,
    loading: true,
  },
  uuid: "",
};

export const adminSlice = createSlice({
  name: "adminSlice",
  initialState,
  reducers: {
    setSidebarTab: (
      state: IAdminSlice,
      { payload }: { payload: IAdminSlice["sidebar_tab"] },
    ) => {
      state.sidebar_tab = payload;
    },
    setSidebarTabSub: (
      state: IAdminSlice,
      { payload }: { payload: IAdminSlice["sidebar_tab_sub"] },
    ) => {
      state.sidebar_tab_sub = payload;
    },
    setPages: (
      state: IAdminSlice,
      {
        payload,
      }: {
        payload: {
          pages: IAdminSlice["pages"];
          set_page?: string;
        };
      }
    ) => ({
      ...state,
      pages: payload.pages,
      current_page: payload.set_page || state.current_page,
      loading: false,
    }),
    setCurrentPage: (
      state: IAdminSlice,
      { payload }: { payload: IAdminSlice["current_page"] },
    ) => ({
      ...state,
      current_page: payload,
    }),
    setLoading: (
      state: IAdminSlice,
      { payload }: { payload: IAdminSlice["loading"] },
    ) => ({
      ...state,
      loading: payload,
    }),
    setAdminPermissions: (
      state: IAdminSlice,
      { payload }: { payload: IAdminSlice["permissions"] },
    ) => ({
      ...state,
      permissions: payload,
    }),
    setAdminTheme: (
      state: IAdminSlice,
      { payload }: { payload: IAdminSlice["theme"] },
    ) => {
      state.theme = payload;
    },
    setAdminConfig: (
      state: IAdminSlice,
      { payload }: { payload: Partial<IAdminSlice["config"]> },
    ) => {
      state.config = {
        ...state.config,
        ...payload,
        loading: false,
      };
    },
    setUuid: (
      state: IAdminSlice,
      { payload }: { payload: IAdminSlice["uuid"] },
    ) => {
      state.uuid = payload;
    },
  },
  extraReducers: (builder) => {
    thunks.forEach((thunk) => buildAction(builder, thunk));
  },
});

export default adminSlice.reducer;
export const {
  setSidebarTab,
  setSidebarTabSub,
  setPages,
  setCurrentPage,
  setLoading,
  setAdminPermissions,
  setAdminTheme,
  setAdminConfig,
  setUuid,
} = adminSlice.actions;
